
//Représente les paramètres d’exécution d’une requête de recherche
export class ASeExecuterRechercheParametres 
{
  //Création
  constructor ()
  {
    this.definitionsTris = [];
    this.definitionsFiltres = [];
  }

  //Domaine
  public domaine!: string;

  //Identifiant de l’onglet
  public identifiantOnglet!: string;

  //Numéro de page
  public numeroPage!: number;

  //Définitions des tris
  public definitionsTris: ASeDefinitionTri[];

  //Définitions des filtres
  public definitionsFiltres: ASeDefinitionFiltre[];
}

//Représente la définition d’un tri
export class ASeDefinitionTri 
{
  //Champ
  public champ!: string;

  //Direction
  public direction!: string;
}

//Représente la définition d’un filtre
export class ASeDefinitionFiltre 
{
  //Création
  constructor () 
  {
    this.valeurTexte = null;
    this.valeurInt = null;
    this.valeurDate = null;
    this.valeurDecimale = null;
    this.valeurBoolean = null;
  }

  //Nom du champ
  public nomChamp!: string;

  //Opérateur
  public operateur!: string;

  //Valeur texte
  public valeurTexte: string | null;

  //Valeur int
  public valeurInt: number | null;

  //Valeur date
  public valeurDate: Date | null;

  //Valeur décimale
  public valeurDecimale: number | null;

  //Valeur boolean
  public valeurBoolean: boolean | null;
}
